const formRelatedSubCategoriesData = (filteredFacets, cid) => {
  const subCategoriesData = [];
  filteredFacets.forEach(facet => {
    const link = `category.do?cid=${cid}&style=${facet.id}&cl=true`;
    const subcategory = {
      id: facet.id,
      name: facet.name,
      value: facet.name,
      link,
    };
    subCategoriesData.push(subcategory);
  });

  return subCategoriesData;
};

const getAllStyleFacetOptions = facetList => {
  if (facetList.style) {
    return facetList.style.options;
  }
  const leftFacetedList = facetList.filter(facet => facet.name === 'style');
  return leftFacetedList[0].options;
};

const getFilteredFacetOptions = (allOptions, appliedOptions) => {
  const appliedOptionsIds = appliedOptions.map(option => option.id);
  return allOptions.filter(
      option => !appliedOptionsIds.includes(option.id) && option.isActive ===
          'true');
};

const getRelatedSubCategories = (subCategories, cid) => {
  const { facetOptions, appliedFacets } = subCategories;
  const appliedStyleFacetOptions = appliedFacets.style;
  const styleFacetOptions = getAllStyleFacetOptions(facetOptions);
  const filteredFacets = getFilteredFacetOptions(styleFacetOptions, appliedStyleFacetOptions);
  const relatedSubCategories = formRelatedSubCategoriesData(filteredFacets, cid);

  return relatedSubCategories;
};

export {
  formRelatedSubCategoriesData,
  getAllStyleFacetOptions,
  getFilteredFacetOptions,
  getRelatedSubCategories,
};
